import { render, staticRenderFns } from "./GroupPlans.vue?vue&type=template&id=221b6554&scoped=true&"
import script from "./GroupPlans.vue?vue&type=script&lang=ts&"
export * from "./GroupPlans.vue?vue&type=script&lang=ts&"
import style0 from "./GroupPlans.vue?vue&type=style&index=0&id=221b6554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b6554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('221b6554', component.options)
    } else {
      api.reload('221b6554', component.options)
    }
    module.hot.accept("./GroupPlans.vue?vue&type=template&id=221b6554&scoped=true&", function () {
      api.rerender('221b6554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/group-plans/GroupPlans.vue"
export default component.exports